/**
 * Return a brand logo URL for a website.
 *
 * Uses the Google S2 Favicons API at 256 px — reliable, no key needed, and
 * covers virtually every domain.  Clearbit's logo.clearbit.com was shut down
 * after HubSpot's acquisition and no longer resolves.
 *
 * The function is intentionally kept named `clearbitLogoFromWebsite` so that
 * all existing call-sites continue to work without renaming.
 */
export function clearbitLogoFromWebsite(website) {
  if (!website || !String(website).trim()) return '';
  let raw = String(website).trim();
  if (!/^https?:\/\//i.test(raw)) {
    raw = `https://${raw}`;
  }
  try {
    const u = new URL(raw);
    const host = (u.hostname || '').toLowerCase();
    if (!host || !host.includes('.')) return '';
    return `https://www.google.com/s2/favicons?domain=${host}&sz=256`;
  } catch {
    return '';
  }
}
